const personalRanges = ["Engaged", "Short", "Medium", "Long", "Extreme"]
const planetaryRanges = ["Close", "Short", "Medium", "Long", "Extreme"]

const parseRange = (value) => {
    if (typeof value !== "string") return null
    const prefix = value.startsWith("wr") ? "wr" : ""
    const bare = value.slice(prefix.length)
    const bands = bare === "Close" ? planetaryRanges : personalRanges
    const index = bands.indexOf(bare)
    if (index === -1) return null
    return { prefix, bands, index }
}

export const rangeIndex = (value) => {
    const parsed = parseRange(value)
    return parsed ? parsed.index : -1
}

export const stepRange = (value, delta) => {
    const parsed = parseRange(value)
    if (!parsed) return value
    const { prefix, bands, index } = parsed
    return prefix + bands[Math.min(Math.max(index + delta, 0), bands.length - 1)]
}
